import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';
import { NotifyService } from './shared/notify.service';

// import tablas
import { table } from '../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class ProveedoresService {

  // Data Bancos
  bancos: any;

  // Data Paises
  paises: any;

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
    public _notifyService: NotifyService
  ) { }

  // Nuevo Proveedores
  public newProveedor(newProv) {
    let objStr = JSON.stringify(newProv);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    //console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prov}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prov}","objc":${objStr}}`
    ).pipe(map
      ((res: any) => {
        return res;
      }));
  }

  // Consulta todos los prove para datatable
  getProveedores() {
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.prov}"}`)
      .pipe(map
        ((res: Response) => {
          let dataUser = { data: res }
          return dataUser;
        }));
  }

  // Valida si el proveedor existe (atributo Nombre, RutSucursal, razonSocial)
  validProv(prov, opt?) {
    let nAtrb;
    if (prov === '' || prov === null) {
      prov = undefined;
    }
    if (opt === 'Nombre') {
      nAtrb = "Nombre";
    }
    else if (opt === 'razonSocial') {
      nAtrb = "razonSocial";
    }
    else if (opt === 'RutSucursal') {
      nAtrb = "RutSucursal";
    }
    // console.log(this._apiRestService.APIURL.serv4 + `/{"tble":"${table.prov}","objc":{"${nAtrb}":"${prov}"}}`);
    return this.http.get(this._apiRestService.APIURL.serv4 + `/{"tble":"${table.prov}","objc":{"${nAtrb}":"${prov}"}}`)
      .pipe(map
        ((res: Response) => {
          return res;
        }));
  }

  // Consulta de Proveedores por padre (prnt)
  public getProveedor(prnt) {
    // console.log(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.prov}","type":"meta","objc":{"prnt":"${prnt}"}}`);
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.prov}","type":"meta","objc":{"prnt":"${prnt}"}}`)
      .pipe(map
        ((res: Response) => {
          return res;
        }));
  }

  // Eliminar proveedor completo, por padre
  delProveedor(prnt) {
    // console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.prov}","prnt":"${prnt}"}`);
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.prov}","prnt":"${prnt}"}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }

  // Editar Proveedor
  public updateProv(prnt, proveedor) {
    let objStr = JSON.stringify(proveedor);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prov}","prnt":"${prnt}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.prov}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(
      map(
        (res: any) => {
          return res;
        }));
  }

  // Eliminar atributo del proveedor, para actualizar
  deleteProvAtrb(prnt, obj) {
    let objStr = JSON.stringify(obj);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.prov}","prnt":"${prnt}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.prov}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }

  // Genera Código al crear nuevo Proveedor
  generarCodigo() {
    let fActual = new Date();
    let codigo = `${fActual.getFullYear().toString()}${(fActual.getMonth() + 1).toString()}${fActual.getDate().toString()}${fActual.getHours().toString()}${fActual.getMinutes().toString()}${fActual.getSeconds().toString()}${fActual.getMilliseconds().toString()}`;
    return codigo;
  }

  // Carga Comunas según Región enviada
  cargarComunasRegion(region, regiones) {
    return regiones.filter(function (obj) {
      return Object.keys(obj).some(function (key) {
        return obj[key].includes(region);
      })
    });
  }

}
